/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import { sortCaret, headerSortingClasses } from '../../components/table/TableSortingHelpers';
import { ButtonIcon, ColumnStatus, WidgetAccount, WidgetDate, WidgetTitleSubtitle } from '../../components';
import NumberFormat from 'react-number-format';
import { Publish } from '@material-ui/icons';
import STATUS_LOAN from '../../constants/loans/statusesRequest';
import STATUS_SIGN from '../../constants/signs/statuses';
import TelegramIcon from '@material-ui/icons/Telegram';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

import React, { useState } from 'react';

const STATUS_ACTIONS = {
    [STATUS_LOAN.pending]: [
        'checkbook', 'sms', 'bill', 'confirm'
    ],
    [STATUS_LOAN.success]: [
        'checkbook'
    ],
    [STATUS_LOAN.cancelled]: [
        // no actions
    ],
    [STATUS_LOAN.rejected]: [
        // no actions
    ],
    [STATUS_LOAN.liquidated]: [
        'checkbook'
    ],
    [STATUS_LOAN.observed]: [
        'checkbook', 'sms', 'bill', 'confirm'
    ],
};

function ButtonIconTimeout ({ disabled, onClick, icon, ...rest }) {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true);
        await onClick();
        setLoading(false);
    };

    if (loading) {
        icon = (
            <Box sx={{ display: 'flex' }}>
                <CircularProgress size={15} style={{ color: '#3699FF' }} />
            </Box>
        );
    }

    return (
        <ButtonIcon
            {...rest}
            icon={icon}
            disabled={loading || disabled}
            onClick={handleClick}
        />
    );
}

export default function LoansColumns ({ downloadCheckbook, openModalUploadBill, openModalConfirmLoan, openModalResendSMS, tabs }) {
    return [
        {
            dataField: 'id',
            text: 'ID',
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses
        },
        {
            dataField: 'created_at',
            text: 'Fecha',
            sort: false,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: cellContent => (<WidgetDate date={new Date(cellContent)} />)
        },
        {
            dataField: 'formattedName',
            text: 'Cliente',
            align: 'left',
            sort: false,
            formatter: cellContent => (
                <WidgetTitleSubtitle
                    title={(<WidgetAccount account={[cellContent]} />)}
                />
            )
        },
        {
            dataField: 'document',
            text: 'DNI',
            sort: false,
            align: 'left',
            headerAlign: 'left',
        },
        {
            dataField: 'amount',
            text: 'Monto',
            sort: false,
            align: 'left',
            headerAlign: 'left',
            formatter: (cellContent, row) => {
                return <NumberFormat value={cellContent} displayType={'text'} thousandSeparator="." decimalSeparator="," prefix={'$'} decimalScale={2} fixedDecimalScale={true} />;
            }
        },
        {
            dataField: 'creditNumber',
            text: 'Nro Crédito',
            sort: false,
            align: 'left',
            headerAlign: 'left',
        },
        {
            dataField: 'status',
            text: 'Estado',
            headerAlign: 'left',
            align: 'left',
            sort: false,
            formatter: (cellContent, row) => {
                const statusType = row.sign_status === STATUS_SIGN.SUCCESS ? 'success' : cellContent.type;
                return <div className='d-flex align-items-center'>
                    <ColumnStatus type={statusType} text={cellContent.text} />
                    {row.sign_status === STATUS_SIGN.SUCCESS &&
                        <i className="fa fa-check-circle text-success ml-1"/>
                    }
                </div>;
            }

        },
        {
            dataField: 'uploadBill',
            text: 'Acciones',
            align: 'center',
            headerAlign: 'center',
            sort: false,
            formatExtraData: {
                openModalUploadBill,
                openModalConfirmLoan,
                openModalResendSMS
            },
            formatter: (cellContent, row, rowIndex, { openModalUploadBill, openModalConfirmLoan, openModalResendSMS }) => {
                const styledIcon = row?.request_files?.length ? '#1BC5BD' : 'inherit';
                return (
                    <>
                        <div className='flex no-wrap justify-center' id={row.id}>
                            <ButtonIconTimeout
                                className="svg-icon"
                                title='Impresion Chequera'
                                size='small'
                                icon={(<AttachFileIcon className="svg-icon  " id='print_bill' />)}
                                onClick={() => downloadCheckbook(row.id, row.creditNumber, row.idExternalPerson)}
                                disabled={!STATUS_ACTIONS[tabs].includes('checkbook')}
                            />
                            <ButtonIcon
                                title='Reenviar SMS'
                                size='small'
                                icon={(<TelegramIcon className="svg-icon" id='resend_sms'/>)}
                                onClick={() => openModalResendSMS(row.id, row.idExternalPerson)}
                                disabled={!STATUS_ACTIONS[tabs].includes('sms') || row.sign_status === STATUS_SIGN.SUCCESS}
                            />
                            <ButtonIcon
                                title='Cargar Factura'
                                size='small'
                                icon={(<Publish className='svg-icon' id='load_bill' style={{ color: styledIcon }}/>)}
                                onClick={() => openModalUploadBill(row.id, row.idExternalPerson)}
                                disabled={!STATUS_ACTIONS[tabs].includes('bill') || row.sign_status !== STATUS_SIGN.SUCCESS}
                            />
                            <ButtonIcon
                                title='Confirmar préstamo'
                                size='small'
                                icon={(<i className="fa fa-check-circle text-primary" id='confirm_loan'/>)} // https://fontawesome.com/v4/icon/check-circle
                                onClick={() => openModalConfirmLoan(row.id)} // es el id de request
                                disabled={!STATUS_ACTIONS[tabs].includes('confirm') || !row?.request_files?.length || row?.sign_status !== STATUS_SIGN.SUCCESS}
                            />
                        </div>
                    </>
                );
            }

        }
    ];
}
